import Header from '../../../Components/Header'
import Lpntable from './Components/Lpn-table'
import { Helmet } from 'react-helmet'

const Picklist = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
       <Helmet>
				<title>Picklist List</title>
			</Helmet>
      <Header />
      <Lpntable />
    </div>
  )
}

export default Picklist